/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerGetQueryResponse, IncidentInvestigationControllerGetPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerGet";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerGet } from "../../clients/incident-agentService/incidentInvestigationControllerGet";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerGetQueryKey = (id: IncidentInvestigationControllerGetPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerGetQueryKey = ReturnType<typeof incidentInvestigationControllerGetQueryKey>;
export function incidentInvestigationControllerGetQueryOptions(id: IncidentInvestigationControllerGetPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerGetQueryKey(id);
  return queryOptions<IncidentInvestigationControllerGetQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerGetQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerGet(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id}
 */
export function useIncidentInvestigationControllerGet<TData = IncidentInvestigationControllerGetQueryResponse, TQueryData = IncidentInvestigationControllerGetQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerGetQueryKey>(id: IncidentInvestigationControllerGetPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerGetQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerGetQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}